import Axios from 'axios/index';
import { get, map, startCase } from 'lodash';
import { push } from 'react-router-redux';
import { toastr } from 'react-redux-toastr';
import queryString from '../../../helpers/queryString';
import handleErrorResponse from '../../../helpers/handleErrorResponse';

import { ADD_RESOURCE } from '../../layout/redux/breadcrumb';
const SET_PRODUCTS_LIST = 'socrates-online/scheme/SET_PRODUCTS_LIST';
const SET_DESTINATIONS = 'socrates-online/scheme/SET_DESTINATIONS';
const SET_PRODUCT_OPTIONS = 'socrates-online/scheme/SET_PRODUCT_OPTIONS';
const SET_PRODUCT = 'socrates-online/scheme/SET_PRODUCT';
const SET_FEE_SCHEME = 'socrates-online/scheme/SET_FEE_SCHEME';
const SET_INSURERS = 'socrates-online/scheme/SET_INSURERS';
const SET_INSURER_LIST = 'socrates-online/scheme/SET_INSURER_LIST';
const SET_INSURER_SCHEMES = 'socrates-online/scheme/SET_INSURER_SCHEMES';
const SET_INSURER_DOCUMENTS = 'socrates-online/scheme/SET_INSURER_DOCUMENTS';
const SET_INSURER = 'socrates-online/scheme/SET_INSURER';
const IS_LOADING = 'socrates-online/scheme/IS_LOADING';
const IS_LOADING_RATES = 'socrates-online/scheme/IS_LOADING_RATES';
const IS_COPYING = 'socrates-online/scheme/IS_COPYING';
const IS_EDITING = 'socrates-online/scheme/IS_EDITING';
const IS_IMPORTING = 'socrates-online/scheme/IS_IMPORTING';
const IS_EXPORTING = 'socrates-online/scheme/IS_EXPORTING';
const IS_SUBMITTING = 'socrates-online/scheme/IS_SUBMITTING';
const CLEAR_DATA = 'socrates-online/scheme/CLEAR_DATA';
const UPDATE_INSURER_SUCCESS = 'socrates-online/scheme/UPDATE_INSURER_SUCCESS';
const FINISH_UPDATE_INSURER = 'socrates-online/scheme/UPDATE_INSURER_SUCCESS';
const SET_SCHEME_GROUP_LIST = 'socrates-online/scheme/SET_SCHEME_GROUP_LIST';
const SET_SCHEMES_TO_UPDATE = 'socrates-online/scheme/SET_SCHEMES_TO_UPDATE';

const SET_SCHEME_GROUP_DETAILS = 'socrates-online/scheme/SET_SCHEME_GROUP_DETAILS';
const SET_SCHEME_DETAILS = 'socrates-online/scheme/SET_SCHEME_DETAILS';
const SET_SCHEME_TYPE = 'socrates-online/scheme/SET_SCHEME_TYPE';
const SET_SCHEME_RULES_REFERENCE_MODEL =
  'socrates-online/scheme/SET_SCHEME_RULES_REFERENCE_MODEL';
const SET_SCHEME_HANDLERS_REFERENCE_MODEL =
  'socrates-online/scheme/SET_SCHEME_HANDLERS_REFERENCE_MODEL';
const SET_SCHEME_SMS_CONFIRMATION_ANNUAL_REFERENCE_MODEL =
  'socrates-online/scheme/SET_SCHEME_SMS_CONFIRMATION_ANNUAL_REFERENCE_MODEL';
const SET_SCHEME_SMS_CONFIRMATION_SINGLE_REFERENCE_MODEL =
  'socrates-online/scheme/SET_SCHEME_SMS_CONFIRMATION_SINGLE_REFERENCE_MODEL';
const SET_SCHEME_DESTINATIONS_MAPPING_SINGLE_REFERENCE_MODEL =
  'socrates-online/scheme/SET_SCHEME_DESTINATIONS_MAPPING_SINGLE_REFERENCE_MODEL';
const SET_SCHEME_DESTINATIONS_MAPPING_ANNUAL_REFERENCE_MODEL =
  'socrates-online/scheme/SET_SCHEME_DESTINATIONS_MAPPING_ANNUAL_REFERENCE_MODEL';
const SET_SCHEME_CHANNELS = 'socrates-online/scheme/SET_SCHEME_CHANNELS';
const SET_ANCILLARY_SCHEMES = 'socrates-online/scheme/SET_ANCILLARY_SCHEMES';
const SET_SCHEME_LINT_FAILURES = 'socrates-online/scheme/SET_SCHEME_LINT_FAILURES';
const SET_FEES = 'socrates-online/scheme/SET_FEES';

export const initialState = {
  isLoading: false,
  isLoadingRates: {
    id: null,
    status: false,
  },
  isCopying: false,
  isEditing: false,
  isImporting: false,
  isExporting: false,
  isSubmitting: false,
  schemeType: null,
  products: {},
  productsList: [],
  product: null,
  scheme: null,
  schemeGroupDetails: undefined,
  schemeDetails: undefined,
  feeList: undefined,
  schemeGroupList: [],
  destinations: null,
  insurers: null,
  insurerList: [],
  insurer: null,
  hasInsurerBeenUpdated: false,
  syncSchemes: [],
  productOptions: null,
  activeFeeScheme: null,
  valuesToTransform: [],
  topLevelArea: {
    schemes: [],
  },
  channels: [],
  ancillarySchemes: null,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.status,
      };
    case IS_LOADING_RATES:
      return {
        ...state,
        isLoadingRates: {
          id: action.data.id,
          status: action.data.status,
          message: action.data.message,
        },
      };
    case IS_COPYING:
      return {
        ...state,
        isCopying: action.status,
      };
    case IS_SUBMITTING:
      return {
        ...state,
        isSubmitting: action.data,
      };
    case IS_EDITING:
      return {
        ...state,
        isEditing: action.status,
      };
    case IS_IMPORTING:
      return {
        ...state,
        isImporting: action.status,
      };
    case IS_EXPORTING:
      return {
        ...state,
        isExporting: action.status,
      };
    case SET_PRODUCTS_LIST:
      return {
        ...state,
        productList: action.data,
      };
    case SET_PRODUCT:
      return {
        ...state,
        product: action.data,
      };
    case SET_FEE_SCHEME:
      return {
        ...state,
        activeFeeScheme: action.data,
      };
    case SET_INSURERS:
      return {
        ...state,
        insurers: action.data,
      };
    case SET_INSURER_LIST:
      return {
        ...state,
        insurerList: action.data,
      };
    case SET_INSURER:
      return {
        ...state,
        insurer: action.data,
      };
    case SET_INSURER_SCHEMES:
      return {
        ...state,
        insurer: {
          ...state.insurer,
          schemes: action.data,
        },
      };
    case SET_INSURER_DOCUMENTS:
      return {
        ...state,
        insurer: {
          ...state.insurer,
          documents: action.data,
        },
      };
    case SET_DESTINATIONS:
      return {
        ...state,
        destinations: action.data,
      };
    case SET_PRODUCT_OPTIONS:
      return {
        ...state,
        productOptions: action.data,
      };
    case SET_SCHEME_GROUP_LIST:
      return {
        ...state,
        schemeGroupList: action.data.data,
      };
    case SET_SCHEMES_TO_UPDATE:
      return {
        ...state,
        schemesToUpdate: action.data,
      };

    case UPDATE_INSURER_SUCCESS:
      return {
        ...state,
        hasInsurerBeenUpdated: true,
      };
    case FINISH_UPDATE_INSURER:
      return {
        ...state,
        hasInsurerBeenUpdated: false,
      };
    case SET_SCHEME_GROUP_DETAILS:
      return {
        ...state,
        schemeGroupDetails: action.data,
      };
    case SET_SCHEME_DETAILS:
      return {
        ...state,
        schemeDetails: action.data,
      };
    case SET_SCHEME_TYPE:
      return {
        ...state,
        schemeType: action.data,
      };

    case SET_SCHEME_RULES_REFERENCE_MODEL:
      return {
        ...state,
        topLevelArea: {
          ...state.topLevelArea,
          [action.data.insurerCode]: {
            schemes: action.data.schemes,
            parameters: action.data.parameters,
          },
        },
      };
    case SET_SCHEME_HANDLERS_REFERENCE_MODEL:
      return {
        ...state,
        topLevelArea: {
          ...state.topLevelArea,
          [action.data.insurerCode]: {
            schemes: action.data.schemes,
            parameters: action.data.parameters,
          },
        },
      };
    case SET_SCHEME_SMS_CONFIRMATION_ANNUAL_REFERENCE_MODEL:
      return {
        ...state,
        topLevelArea: {
          ...state.topLevelArea,
          annualSchemeMeta: {
            [action.data.insurerCode]: {
              schemes: action.data.schemes,
              parameters: {
                ...action.data.parameters,
                smsMessage: action.data.parameters?.smsMessage ?? '',
              },
            },
          },
        },
      };
    case SET_SCHEME_SMS_CONFIRMATION_SINGLE_REFERENCE_MODEL:
      return {
        ...state,
        topLevelArea: {
          ...state.topLevelArea,
          singleSchemeMeta: {
            [action.data.insurerCode]: {
              schemes: action.data.schemes,
              parameters: {
                ...action.data.parameters,
                smsMessage: action.data.parameters?.smsMessage ?? '',
              },
            },
          },
        },
      };
    case SET_SCHEME_DESTINATIONS_MAPPING_SINGLE_REFERENCE_MODEL:
      return {
        ...state,
        topLevelArea: {
          ...state.topLevelArea,
          singleSchemeMeta: {
            [action.data.insurerCode]: {
              schemes: action.data.schemes,
              parameters: action.data.parameters,
            },
          },
        },
      };
    case SET_SCHEME_DESTINATIONS_MAPPING_ANNUAL_REFERENCE_MODEL:
      return {
        ...state,
        topLevelArea: {
          ...state.topLevelArea,
          annualSchemeMeta: {
            [action.data.insurerCode]: {
              schemes: action.data.schemes,
              parameters: action.data.parameters,
            },
          },
        },
      };

    case SET_SCHEME_CHANNELS:
      return {
        ...state,
        channels: action.data,
      };

    case SET_SCHEME_LINT_FAILURES:
      return {
        ...state,
        lintFailures: action.data,
      };

    case SET_ANCILLARY_SCHEMES:
      return {
        ...state,
        ancillarySchemes: action.data,
      };

    case SET_FEES:
      return {
        ...state,
        isLoading: false,
        feeList: [...action.data.data],
      };
    case CLEAR_DATA:
      return initialState;
    default:
      return state;
  }
}

const clearData = () => {
  return {
    type: CLEAR_DATA,
  };
};

const isLoading = (status) => {
  return {
    type: IS_LOADING,
    status,
  };
};

const isImporting = (status) => {
  return {
    type: IS_IMPORTING,
    status,
  };
};

const isEditing = (status) => {
  return {
    type: IS_EDITING,
    status,
  };
};

const activateScheme = (schemeId, values, isSchemeGroup) => {
  const endpoint = isSchemeGroup ? 'products/scheme-groups/' : 'products/schemes/';

  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post(endpoint + schemeId + ':activate', values)
      .then((resp) => {
        toastr.success('Success', 'Scheme has been activated');
        return resp.data;
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed to activate scheme');
      })
      .finally(() => {
        dispatch(isSubmitting(false));
      });
  };
};

const activateFeeScheme = (schemeId, values) => {
  const endpoint = 'products/fee-schemes/';

  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post(endpoint + schemeId + ':activate', values)
      .then((resp) => {
        toastr.success('Success', 'Scheme has been activated');
        return resp.data;
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed to activate scheme');
      })
      .finally(() => {
        dispatch(isSubmitting(false));
      });
  };
};

const lintScheme = (schemeId, isSchemeGroup) => {
  const endpoint = isSchemeGroup ? 'products/scheme-groups/' : 'products/schemes/';

  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post(endpoint + schemeId + '/configuration:lint')
      .then((response) => {
        dispatch({ type: SET_SCHEME_LINT_FAILURES, data: response.data });
        dispatch(isSubmitting(false));
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed to lint scheme');
        dispatch(isSubmitting(false));
      });
  };
};

const exportSchemes = (productId, values) => {
  const endpoint = 'products/' + productId + ':export';

  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post(endpoint, values)
      .then((response) => {
        if (window && response.data.meta.file_name) {
          window.open(response.data.meta.file_name, '_blank');
        }
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed to export scheme');
      })
      .finally(() => {
        dispatch(isSubmitting(false));
      });
  };
};

const adminFeeEditRates = (schemeId) => {
  return (dispatch) => {
    dispatch(isEditing(true));
    return Axios.post('products/fee-schemes/' + schemeId + ':edit-rates', {})
      .then((response) => {
        dispatch(isEditing(false));

        if (window && response.data.meta.url) {
          window.open(response.data.meta.url, '_blank');
        }
        return true;
      })
      .catch((error) => {
        dispatch(isEditing(false));
        handleErrorResponse(error, 'Failed to get scheme document URL');
      });
  };
};

const adminFeeImportRates = (schemeId) => {
  return (dispatch) => {
    dispatch(isImporting(true));
    return Axios.post('products/fee-schemes/' + schemeId + ':import-rates', {})
      .then(() => {
        dispatch(getAdminFees(schemeId));
        dispatch(isImporting(false));
        toastr.success('Success', 'Your rates have been imported');
        return true;
      })
      .catch((error) => {
        dispatch(isImporting(false));
        handleErrorResponse(error, 'Failed to get scheme document URL');
      });
  };
};

export function fetchFees() {
  const END_POINT =
    '/products/fee-schemes?page[limit]=10&filter[status]=test,active,ended';
  return (dispatch) => {
    return Axios.get(END_POINT).then((response) => {
      dispatch({
        type: SET_FEES,
        data: response.data,
      });
      return true;
    });
  };
}

const assignHandlerToScheme = (scheme, handlerType, values, schemeType) => {
  let action = 'assign-';
  let endpoint = 'products/schemes/';

  if (schemeType === 'schemeGroup') {
    endpoint = 'products/scheme-groups/';
  }

  if (handlerType === 'Claims Handler') {
    action += 'claims-handler';
  }

  if (handlerType === 'Assistance Handler') {
    action += 'assistance-handler';
  }

  return (dispatch) => {
    dispatch(isEditing(true));
    return Axios.post(endpoint + scheme.id + ':' + action, values)
      .then(() => {
        // dispatch(getSchemeDetails(scheme.id))
        dispatch(isEditing(false));
        toastr.success('Success', handlerType + ' assigned');
        return true;
      })
      .catch((error) => {
        dispatch(isEditing(false));
        handleErrorResponse(error, 'Failed to assign ' + handlerType);
      });
  };
};

const createNewVersion = (schemeId, isSchemeGroup) => {
  const endpoint = isSchemeGroup ? 'products/scheme-groups/' : 'products/schemes/';

  return () => {
    return Axios.patch(`${endpoint}${schemeId}`, {
      meta: {
        queue: true,
      },
    })
      .then(() => {
        toastr.success('Success', 'Request for new scheme version sent');
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error updating the scheme');
      });
  };
};

const editAggregatorMapping = (scheme, isSchemeGroup) => {
  let endpoint = 'products/schemes/';

  if (isSchemeGroup) {
    endpoint = 'products/scheme-groups/';
  }

  return (dispatch) => {
    dispatch(isEditing(true));
    return Axios.post(endpoint + scheme.id + ':edit-aggregator-mappings', {})
      .then((response) => {
        dispatch(isEditing(false));

        if (window && response.data.meta.url) {
          window.open(response.data.meta.url, '_blank');
        }
        return true;
      })
      .catch((error) => {
        dispatch(isEditing(false));
        handleErrorResponse(error, 'Failed to get scheme document URL');
      });
  };
};

const editRates = (schemeId, isSchemeGroup, loadingMessage) => {
  let endpoint = 'products/schemes/';

  if (isSchemeGroup) {
    endpoint = 'products/scheme-groups/';
  }

  return (dispatch) => {
    dispatch(isLoadingRates(true, schemeId, loadingMessage));
    return Axios.post(endpoint + schemeId + ':edit-rates', {})
      .then((response) => {
        dispatch(isLoadingRates(false, schemeId, loadingMessage));

        if (window && response.data.meta.url) {
          window.open(response.data.meta.url, '_blank');
        }
        return true;
      })
      .catch((error) => {
        dispatch(isLoadingRates(false, schemeId, loadingMessage));
        handleErrorResponse(error, 'Failed to get scheme document URL');
      });
  };
};

const endOrDeactivateScheme = (schemeId, end, isSchemeGroup) => {
  const action = end ? 'end' : 'deactivate';
  let endpoint = 'products/schemes/';

  if (isSchemeGroup) {
    endpoint = 'products/scheme-groups/';
  }

  return () => {
    return Axios.post(endpoint + schemeId + ':' + action)
      .then(() => {
        // dispatch(getProduct());
        toastr.success('Success', `Scheme has been ${end ? 'ended' : 'deactivated'}`);
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed to deactivate scheme');
      });
  };
};

const getDestinations = () => {
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get('products/destinations?page[limit]=500')
      .then((response) => {
        dispatch({
          type: SET_DESTINATIONS,
          data: response.data.data,
        });
        dispatch(isLoading(false));
        return true;
      })
      .finally(() => {
        dispatch(isLoading(false));
      });
  };
};

const getProductOptions = () => {
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get('products/options?filters=[products/options]=name&page[limit]=30')
      .then((response) => {
        dispatch({ type: SET_PRODUCT_OPTIONS, data: response.data.data });
        dispatch(isLoading(false));
        return true;
      })
      .catch(() => {
        dispatch(isLoading(false));
      });
  };
};

const getFeeScheme = (feeSchemeId) => {
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get('products/fee-schemes/' + feeSchemeId)
      .then((response) => {
        dispatch({
          type: SET_FEE_SCHEME,
          data: response.data,
        });
        dispatch(isLoading(false));
        return true;
      })
      .catch(() => {
        dispatch(isLoading(false));
      });
  };
};

const getInsurer = (insurerId, includes = []) => {
  const endpoint = `organisations/insurers/${insurerId}`;

  return (dispatch) => {
    dispatch({ type: SET_INSURER, data: undefined });
    dispatch(isLoading(true));
    return Axios.get(endpoint + queryString(includes, [], [], 500))
      .then((response) => {
        if (insurerId) {
          dispatch({ type: SET_INSURER, data: response.data });
        }

        return true;
      })
      .finally(() => {
        dispatch(isLoading(false));
      });
  };
};

const getInsurerList = (includes = []) => {
  const endpoint = 'organisations/insurers';
  const pagelimit = '&page[limit]=500';

  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get(endpoint + queryString(includes) + pagelimit)
      .then((response) => {
        dispatch({ type: SET_INSURER_LIST, data: response.data });
        dispatch(isLoading(false));
        return true;
      })
      .catch(() => {
        dispatch(isLoading(false));
      });
  };
};

const getInsurerSchemes = (insurerCode, includes, meta) => {
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get(
      `products/schemes?page[limit]=100&filter[insurer]=${insurerCode}&filter[status]=all${
        includes ? '&include=' + includes.join() : ''
      }${meta ? '&meta=' + meta.join() : ''}`,
    )
      .then((response) => {
        const schemeGroupExists =
          response.data.included &&
          !!response.data.included.find((included) => {
            return included.type === 'products/scheme-groups';
          });
        if (schemeGroupExists) {
          dispatch(getSchemeGroupList(insurerCode));
        } else {
          dispatch({
            type: SET_INSURER_SCHEMES,
            data: response.data.data,
          });
          dispatch({
            type: SET_INSURER_DOCUMENTS,
            data: {
              documents: response.data.included
                ? response.data.included.filter(
                    (included) => included.type === 'documents',
                  )
                : [],
              types: response.data.included
                ? response.data.included.filter(
                    (included) => included.type === 'documents/types',
                  )
                : [],
            },
          });
        }
        dispatch(isLoading(false));
        return true;
      })
      .catch(() => {
        dispatch(isLoading(false));
      });
  };
};

const getInsurerSchemesByStatus = (status, insurerCode, include = ['channels']) => {
  const endpoint = `/products/schemes/?filter[insurer]=${insurerCode}&filter[status]=${status}`;

  const includes = '&include=' + include.join(',');

  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get(`${endpoint}${includes}`)
      .then((response) => {
        dispatch(isLoading(false));
        return response.data.data;
      })
      .catch(() => {
        dispatch(isLoading(false));
      });
  };
};

const getProductSchemesByStatus = (status, productId) => {
  const endpoint = `/products/schemes/?filter[product]=${productId}&filter[status]=${status}`;

  const include = ['channels'];
  const includes = '&include=' + include.join(',');

  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get(`${endpoint}${includes}`)
      .then((response) => {
        dispatch(isLoading(false));
        return response.data.data;
      })
      .catch(() => {
        dispatch(isLoading(false));
      });
  };
};

const removeChannelsFromScheme = (schemeId, values) => {
  return (dispatch) => {
    return Axios.post(`product-management/${schemeId}/remove-channels`, values)
      .then(() => {
        dispatch(isLoading(false));
        return true;
      })
      .catch(() => {
        dispatch(isLoading(false));
      });
  };
};

const assignChannelsToScheme = (schemeId, values) => {
  return (dispatch) => {
    return Axios.post(`product-management/${schemeId}/assign-channels`, values)
      .then(() => {
        dispatch(isLoading(false));
        return true;
      })
      .catch(() => {
        dispatch(isLoading(false));
      });
  };
};

const getInsurerDestinationMapping = (insurerCode, isSchemeGroup) => {
  const reference = isSchemeGroup ? 'reference-scheme-groups' : 'reference-schemes';
  const endpoint = `/product-management/${reference}/${insurerCode}/destinations?filter[scheme_types]=annual,single`;

  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get(`${endpoint}`)
      .then((response) => {
        const single = response.data.meta.single;
        dispatch({
          type: SET_SCHEME_DESTINATIONS_MAPPING_SINGLE_REFERENCE_MODEL,
          data: {
            insurerCode: insurerCode,
            schemes: single.schemes,
            parameters: {
              destination_mapping: single.destination_mapping,
              regions: single.regions,
              rules: single.exclude_destinations,
            },
          },
        });
        const annual = response.data.meta.annual;
        dispatch({
          type: SET_SCHEME_DESTINATIONS_MAPPING_ANNUAL_REFERENCE_MODEL,
          data: {
            insurerCode: insurerCode,
            schemes: annual.schemes,
            parameters: {
              destination_mapping: annual.destination_mapping,
              regions: annual.regions,
              rules: annual.exclude_destinations,
            },
          },
        });

        return true;
      })
      .finally(() => {
        dispatch(isLoading(false));
      });
  };
};

const getInsurerMedicalRules = (insurerCode, isSchemeGroup) => {
  const reference = isSchemeGroup ? 'reference-scheme-groups' : 'reference-schemes';
  const endpoint = `/product-management/${reference}/${insurerCode}/medical-rules`;
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get(`${endpoint}`)
      .then((response) => {
        dispatch({
          type: SET_SCHEME_RULES_REFERENCE_MODEL,
          data: {
            insurerCode: insurerCode,
            schemes: response.data.meta?.schemes,
            parameters: {
              medicalDeclarationQuestions:
                response.data.meta?.medical_declaration_questions,
              medicalDeclarationQuestionExclusions:
                response.data.meta?.medical_declaration_questions_exclusion,
              allowMedicalExclusion: response.data.meta?.allow_medical_exclusion,
            },
          },
        });
        return true;
      })
      .finally(() => {
        dispatch(isLoading(false));
      });
  };
};

const getInsurerHandlers = (insurerCode, isSchemeGroup) => {
  const reference = isSchemeGroup ? 'reference-scheme-groups' : 'reference-schemes';
  const endpoint = `/product-management/${reference}/${insurerCode}/handlers?filter[status]=all`;
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get(`${endpoint}`)
      .then((response) => {
        dispatch({
          type: SET_SCHEME_HANDLERS_REFERENCE_MODEL,
          data: {
            insurerCode: insurerCode,
            schemes: response.data.meta?.schemes,
            parameters: {
              assignedClaimsHandler: response.data.meta?.assigned_claims_handler,
              assignedAssistanceHandler: response.data.meta?.assigned_assistance_handler,
              claimsHandlerInfo: response.data.meta?.claims_handler_info,
              assistanceHandlerInfo: response.data.meta?.assistance_handler_info,
            },
          },
        });
        return true;
      })
      .finally(() => {
        dispatch(isLoading(false));
      });
  };
};

const getInsurerSmsConfirmationMessage = (insurerCode, isSchemeGroup) => {
  const reference = isSchemeGroup ? 'reference-scheme-groups' : 'reference-schemes';
  const endpoint = `/product-management/${reference}/${insurerCode}/sms-message?filter[scheme_types]=annual,single&filter[status]=all`;
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get(`${endpoint}`)
      .then((response) => {
        const single = response.data.meta.single;
        dispatch({
          type: SET_SCHEME_SMS_CONFIRMATION_SINGLE_REFERENCE_MODEL,
          data: {
            insurerCode: insurerCode,
            schemes: single.schemes,
            parameters: {
              smsMessage: single?.sms_message,
            },
          },
        });
        const annual = response.data.meta.annual;
        dispatch({
          type: SET_SCHEME_SMS_CONFIRMATION_ANNUAL_REFERENCE_MODEL,
          data: {
            insurerCode: insurerCode,
            schemes: annual.schemes,
            parameters: {
              smsMessage: annual?.sms_message,
            },
          },
        });
        return true;
      })
      .finally(() => {
        dispatch(isLoading(false));
      });
  };
};

const getProduct = (productId, includes) => {
  const endpoint = `products/${productId}`;

  return (dispatch) => {
    dispatch({ type: SET_PRODUCT, data: undefined });
    dispatch(isLoading(true));
    return Axios.get(endpoint + queryString(includes))
      .then((response) => {
        dispatch({ type: SET_PRODUCT, data: response.data });
        dispatch({
          type: ADD_RESOURCE,
          id: response.data.data.id,
          name: response.data.data.attributes.name,
        });
        dispatch(isLoading(false));
        return true;
      })
      .finally(() => {
        dispatch(isLoading(false));
      });
  };
};

const getProductsList = () => {
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get('products')
      .then((response) => {
        dispatch({ type: SET_PRODUCTS_LIST, data: response.data.data });

        dispatch(isLoading(false));
        return response.data;
      })
      .finally(() => {
        dispatch(isLoading(false));
      });
  };
};

const getSchemeDetails = (schemeId) => {
  return (dispatch) => {
    const includes = ['claims_handler', 'assistance_handler', 'insurer', 'renews_to'];
    const meta = ['config', 'options', 'benefits', 'rates', 'rules', 'parameters'];

    const endpoint = `/products/schemes/${schemeId}${queryString(includes, meta)}`;
    return Axios.get(endpoint).then((response) => {
      dispatch(
        setSchemeDetailsNew(
          response.data.data,
          response.data.included,
          response.data.meta,
        ),
      );
      dispatch({
        type: ADD_RESOURCE,
        id: response.data.data.id,
        name: response.data.data.attributes.name,
      });
    });
  };
};

const setSchemeGroupDetails = (scheme, included = null, meta = null) => {
  return (dispatch) => {
    dispatch({
      type: SET_SCHEME_GROUP_DETAILS,
      data: { data: scheme, included: included, meta: meta },
    });
  };
};

const clearSchemeGroupDetails = () => {
  return (dispatch) => {
    dispatch({
      type: SET_SCHEME_GROUP_DETAILS,
      data: undefined,
    });
  };
};

const clearSchemeDetails = () => {
  return (dispatch) => {
    dispatch({
      type: SET_SCHEME_DETAILS,
      data: undefined,
    });
  };
};

const setSchemeDetailsNew = (scheme, included = null, meta = null) => {
  return (dispatch) => {
    dispatch({
      type: SET_SCHEME_DETAILS,
      data: { data: scheme, included: included, meta: meta },
    });
  };
};

const getSchemeGroupDetails = (schemeId) => {
  return (dispatch) => {
    const endpoint = `/products/scheme-groups/${schemeId}`;
    const includes = [
      'all_schemes.claims_handler',
      'all_schemes.assistance_handler',
      'all_schemes.renews_to',
      // 'all_schemes.insurer',
      'insurer',
    ];
    const meta = ['config', 'options', 'benefits', 'rates', 'rules', 'parameters'];

    return Axios.get(endpoint + queryString(includes, meta)).then((response) => {
      dispatch(
        setSchemeGroupDetails(
          response.data.data,
          response.data.included,
          response.data.meta,
        ),
      );
      dispatch({
        type: ADD_RESOURCE,
        id: response.data.data.id,
        name: response.data.data.attributes.name,
      });
    });
  };
};

const getSchemeGroupList = (insurerCode) => {
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get(
      `products/scheme-groups?sort=-version_number&filter[name]=${insurerCode}`,
    )
      .then((response) => {
        if (response.data.data.length === 0) {
          dispatch(setSchemeType('scheme'));
        }

        if (response.data.data.length > 0) {
          dispatch(setSchemeType('schemeGroup'));
          dispatch({ type: SET_SCHEME_GROUP_LIST, data: response.data });
        }
        dispatch(isLoading(false));
        return true;
      })
      .catch(() => {
        dispatch(isLoading(false));
      });
  };
};

const importAggregatorMapping = (scheme, isSchemeGroup) => {
  let endpoint = 'products/schemes/';

  if (isSchemeGroup) {
    endpoint = 'products/scheme-groups/';
  }

  return (dispatch) => {
    dispatch(isImporting(true));
    return Axios.post(endpoint + scheme.id + ':import-aggregator-mappings', {})
      .then(() => {
        // dispatch(getScheme(scheme.id))
        dispatch(isImporting(false));
        toastr.success('Success', 'Your mappings have been imported');
        return true;
      })
      .catch((error) => {
        dispatch(isImporting(false));
        handleErrorResponse(error, 'Failed to get scheme document URL');
      });
  };
};

const importRates = (schemeId, isSchemeGroup, loadingMessage) => {
  let endpoint = 'products/schemes/';

  if (isSchemeGroup) {
    endpoint = 'products/scheme-groups/';
  }

  return (dispatch) => {
    dispatch(isLoadingRates(true, schemeId, loadingMessage));
    return Axios.post(endpoint + schemeId + ':import-rates', {})
      .then(() => {
        // dispatch(getScheme(scheme.id))
        dispatch(isLoadingRates(false, schemeId, loadingMessage));
        toastr.success('Success', 'Your rates have been imported');
        return true;
      })
      .catch((error) => {
        dispatch(isLoadingRates(false, schemeId, loadingMessage));
        handleErrorResponse(error, 'Failed to get scheme document URL');
      });
  };
};

const isLoadingRates = (status, schemeId, message) => {
  return {
    type: IS_LOADING_RATES,
    data: {
      id: schemeId,
      status: status,
      message: message,
    },
  };
};

const isSubmitting = (state) => ({ type: IS_SUBMITTING, data: state });

const setSchemesToUpdate = (schemes) => ({ type: SET_SCHEMES_TO_UPDATE, data: schemes });

const lockRates = (schemeId, isSchemeGroup, loadingMessage) => {
  let endpoint = 'products/schemes/';

  if (isSchemeGroup) {
    endpoint = 'products/scheme-groups/';
  }

  return (dispatch) => {
    dispatch(isLoadingRates(true, schemeId, loadingMessage));
    return Axios.post(endpoint + schemeId + ':lock-rates', {})
      .then(() => {
        dispatch(isLoadingRates(false, schemeId, loadingMessage));
        toastr.success('Success', 'Rates have been locked');
        return true;
      })
      .catch((error) => {
        dispatch(isLoadingRates(false, schemeId, loadingMessage));
        handleErrorResponse(error, 'Failed to lock rates');
      });
  };
};

const setSchemeType = (schemeType) => ({ type: SET_SCHEME_TYPE, data: schemeType });

const updateDocumentPacks = (packs, productId) => {
  return () => {
    return Axios.patch(
      'products/' +
        productId +
        '/document-packs' +
        queryString(['document_packs.scheme_documents']),
      packs,
    )
      .then(() => {
        toastr.success('Success', 'Your changes have been saved');
        return true;
      })
      .catch((error) => {
        handleErrorResponse(
          error,
          'There was an error updating the product document packs',
        );
      });
  };
};

const updateAdminFees = (resource) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    const id = resource.data.id;
    return Axios.patch('products/fee-schemes/' + id, resource)
      .then((response) => {
        toastr.success('Success', 'A New version has been created');
        dispatch({
          type: SET_FEE_SCHEME,
          data: response.data,
        });
        dispatch(isSubmitting(false));
        return true;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'There was an error updating the fees');
      });
  };
};

const updateInsurer = (insurer) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    const id = insurer.data.id;
    let endpoint = 'organisations/insurers/' + id;

    return Axios.patch(endpoint, insurer)
      .then(() => {
        dispatch(isSubmitting(false));
        toastr.success('Success', 'Insurer ' + insurer.data.id + ' has been updated');
        dispatch({ type: UPDATE_INSURER_SUCCESS });
        dispatch(getInsurerList());
        return true;
      })
      .then(() => {
        dispatch({ type: FINISH_UPDATE_INSURER });
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'There was an error updating the organisation');
      });
  };
};

const updateMultipleSchemes = (schemes, schemeType) => {
  const endpoint =
    schemeType === 'schemeGroup' ? 'products/scheme-groups/' : 'products/schemes/';
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.patch(endpoint, schemes)
      .then(() => {
        toastr.success('Success', ' Your changes has been saved.');
        dispatch(isSubmitting(false));
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to perform this action.');
      });
  };
};

const updateMedicalRules = (values, isSchemeGroup) => {
  const reference = isSchemeGroup ? 'scheme-group-medical-rules' : 'scheme-medical-rules';
  const endpoint = `product-management/${reference}`;

  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.put(endpoint, values)
      .then(() => {
        toastr.success('Success', ' Your changes has been saved.');
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed to perform this action.');
      })
      .finally(() => {
        dispatch(isSubmitting(false));
      });
  };
};

const updateHandlers = (values, isSchemeGroup) => {
  const reference = isSchemeGroup ? 'scheme-group-handlers' : 'scheme-handlers';
  const endpoint = `product-management/${reference}`;

  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.put(endpoint, values)
      .then(() => {
        toastr.success('Success', ' Your changes has been saved.');
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed to perform this action.');
      })
      .finally(() => {
        dispatch(isSubmitting(false));
      });
  };
};

const updateSanctions = (values) => {
  const endpoint = '/product-management/assign-sanctions';
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post(endpoint, values)
      .then(() => {
        toastr.success('Success', ' Your changes has been saved.');
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed to perform this action.');
      })
      .finally(() => {
        dispatch(isSubmitting(false));
      });
  };
};

const updateDestinationsMapping = (values, tripType, isSchemeGroup) => {
  const reference = isSchemeGroup
    ? 'scheme-group-destinations-mapping'
    : 'scheme-destinations-mapping';
  const endpoint = `product-management/${reference}/${tripType}`;

  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.put(endpoint, values)
      .then(() => {
        toastr.success('Success', ' Your changes has been saved.');
        dispatch(isSubmitting(false));
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to perform this action.');
      });
  };
};

const updateSmsConfirmationMessage = (values, isSchemeGroup) => {
  const reference = isSchemeGroup
    ? 'scheme-group-sms-confirmation-message'
    : 'scheme-sms-confirmation-message';
  const endpoint = `product-management/${reference}/`;

  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.put(endpoint, values)
      .then(() => {
        toastr.success('Success', ' Your changes has been saved.');
        dispatch(isSubmitting(false));
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to perform this action.');
      });
  };
};

const downloadDestinationMapping = (schemes, schemeType) => {
  const endpoint = 'product-management/destinations-mapping:download';
  let payload = { meta: {} };
  payload.meta[schemeType] = schemes;

  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post(endpoint, payload)
      .then((response) => {
        dispatch(isSubmitting(false));
        if (window && response.data.meta.file_name) {
          window.open(response.data.meta.file_name, '_blank');
        }
        return true;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to compile country mapping.');
      });
  };
};

const cloneInsurerSchemes = (insurerId, schemeType, values) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    const insurerToCloneId = values.insurer;
    const endpoint = `/products/schemes/?filter[insurer]=${insurerToCloneId}&filter[status]=all&include=replaced_by`;
    return Axios.get(endpoint)
      .then((response) => {
        const insurerCurrentSchemes = response.data.data.filter((scheme) => {
          return !get(scheme, 'relationships.replaced_by.data.id', false);
        });

        const schemes = map(insurerCurrentSchemes, (scheme) => {
          const name = startCase(
            values.attributes.name +
              ' ' +
              scheme.attributes.scheme_type +
              ' ' +
              scheme.attributes.cover_level,
          );
          //const logo = insurer.attributes.logo
          return {
            attributes: {
              ...values.attributes,
              name: name,
            },
            relationships: {
              insurer: {
                data: {
                  id: insurerId,
                },
              },
              clone: {
                data: {
                  id: scheme.id,
                },
              },
              channel_types: values.data.relationships.channel_types,
            },
          };
        });
        const payload = {
          data: {
            ...schemes,
          },
        };
        const endpoint =
          schemeType === 'schemeGroup'
            ? 'products/scheme-groups/new'
            : 'products/schemes/:clone';
        return Axios.post(endpoint, payload)
          .then(() => {
            toastr.success('Success', ' Your changes has been saved.');
            dispatch(isSubmitting(false));
          })
          .catch((error) => {
            dispatch(isSubmitting(false));
            handleErrorResponse(error, 'Failed to perform this action.');
          });
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to perform this action.');
      });
  };
};

const partiallyUpdateMultipleSchemes = (schemes) => {
  const endpoint = 'products/schemes/';
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.put(endpoint, schemes)
      .then(() => {
        toastr.success('Success', ' Your changes has been saved.');
        dispatch(isSubmitting(false));
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to perform this action.');
      });
  };
};

const updateProduct = (formValues) => {
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.patch('products/' + formValues.data.id, formValues)
      .then((response) => {
        dispatch({
          type: SET_PRODUCT,
          data: response.data,
        });
        dispatch(isLoading(false));
        toastr.success('Success', 'Your changes have been saved');
        // dispatch(push('/admin/products'))
        return true;
      })
      .catch((error) => {
        dispatch(isLoading(false));
        handleErrorResponse(error, 'There was an error updating the product');
      });
  };
};

const updateScheme = (values, schemeId, includes = []) => {
  const endpoint = `products/schemes/${schemeId}${queryString(includes)}`;
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.patch(endpoint, values)
      .then(() => {
        toastr.success('Success', ' Your changes has been saved.');
        dispatch(isSubmitting(false));
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to perform this action.');
      });
  };
};

const updateSchemeGroup = (values, schemeId, includes = []) => {
  const endpoint = `products/scheme-groups/${schemeId}${queryString(includes)}`;
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.patch(endpoint, values)
      .then(() => {
        toastr.success('Success', ' Your changes has been saved.');
        dispatch(isSubmitting(false));
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to perform this action.');
      });
  };
};

const updateSchemeConfiguration = (values, schemeId) => {
  const endpoint = `products/schemes/${schemeId}/configuration`;
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.put(endpoint, values)
      .then(() => {
        toastr.success('Success', ' Your changes has been saved.');
        dispatch(isSubmitting(false));
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to perform this action.');
      });
  };
};

const updateSchemeGroupConfiguration = (values, schemeId) => {
  const endpoint = `products/scheme-groups/${schemeId}/configuration`;
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.put(endpoint, values)
      .then(() => {
        toastr.success('Success', ' Your changes has been saved.');
        dispatch(isSubmitting(false));
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to perform this action.');
      });
  };
};

const viewOrEditScheme = (schemeId, productId, insurerId, schemeType, actionType) => {
  return (dispatch) => {
    dispatch(setSchemeType(schemeType));
    dispatch(
      push(
        `/admin/products/${productId}/insurers/${insurerId}/${schemeId}/${actionType}`,
      ),
    );
  };
};

const getAncillarySchemes = (insurer) => {
  return (dispatch) => {
    const insurerFilter = insurer ? `&filter[insurer]=${insurer}` : '';
    return Axios.get(
      `products/ancillary-schemes?filter[status]=test,active${insurerFilter}&include=replaced_by`,
    ).then((response) => {
      const schemes = response.data.data.reduce((carry, scheme) => {
        if (scheme.relationships.replaced_by.data) {
          return carry;
        }
        if (carry[scheme.attributes.name]) {
          carry[scheme.attributes.name].push(scheme);
        } else {
          carry[scheme.attributes.name] = [scheme];
        }
        return carry;
      }, {});
      dispatch({
        type: SET_ANCILLARY_SCHEMES,
        data: schemes,
      });
      return schemes;
    });
  };
};

const getAdminFees = (id, includes = ['test', 'active', 'ended']) => {
  return (dispatch) => {
    let endpoint = 'products/fee-schemes/' + id;
    endpoint += queryString(includes);

    return Axios.get(endpoint).then((response) => {
      dispatch({
        type: actions.SET_FEES,
        data: response.data,
      });
      return true;
    });
  };
};

export const actions = {
  lintScheme,
  adminFeeEditRates,
  adminFeeImportRates,
  assignHandlerToScheme,
  clearData,
  createNewVersion,
  editAggregatorMapping,
  editRates,
  endOrDeactivateScheme,
  getDestinations,
  getFeeScheme,
  getInsurer,
  getInsurerList,
  getInsurerSchemes,
  getProduct,
  getProductsList,
  getSchemeGroupList,
  importAggregatorMapping,
  importRates,
  lockRates,
  setSchemeType,
  updateDocumentPacks,
  updateAdminFees,
  updateInsurer,
  updateMultipleSchemes,
  cloneInsurerSchemes,
  partiallyUpdateMultipleSchemes,
  updateProduct,
  updateScheme,
  updateSchemeConfiguration,
  viewOrEditScheme,
  setSchemesToUpdate,
  getProductOptions,
  exportSchemes,
  downloadDestinationMapping,
  getInsurerSchemesByStatus,
  getProductSchemesByStatus,
  removeChannelsFromScheme,
  assignChannelsToScheme,
  getAncillarySchemes,
  activateScheme,
  activateFeeScheme,
  getSchemeGroupDetails,
  getSchemeDetails,
  fetchFees,
  updateSchemeGroup,
  updateSchemeGroupConfiguration,
  clearSchemeGroupDetails,
  clearSchemeDetails,
  getInsurerDestinationMapping,
  getInsurerMedicalRules,
  getInsurerHandlers,
  getInsurerSmsConfirmationMessage,
  updateDestinationsMapping,
  updateMedicalRules,
  updateHandlers,
  updateSanctions,
  updateSmsConfirmationMessage,
  getAdminFees,
};
